import { useProductCategories } from '../../../categories/useProductCategories';

export function useSelectedGroceryCategory(props: {
  selectedCategory?: number;
}) {
  const { selectedCategory } = props;

  const { data, isLoading } = useProductCategories();

  return {
    isLoading,
    selectedCategory: data?.results.find(
      (category) => category.id === selectedCategory
    ),
  };
}
